import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAdmin } from '../context/AdminContext';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const AdminAreaReportPrint = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getAuthHeaders, adminLogout } = useAdmin();
  const [html, setHtml] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    const load = async () => {
      setError('');
      try {
        const res = await axios.get(`${API_URL}/api/admin/area-reports/${id}`, {
          headers: getAuthHeaders()
        });
        setHtml(res.data?.html || '');
      } catch (err) {
        if (err.response?.status === 401 || err.response?.status === 403) {
          adminLogout();
          navigate('/admin/login');
          return;
        }
        setError(err.response?.data?.message || 'Failed to load report');
      }
    };
    if (id) load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (error) {
    return (
      <div style={{ padding: '20px' }}>
        <div style={{ marginBottom: '10px', color: '#b00020', fontWeight: 700 }}>{error}</div>
        <button className="action-btn" onClick={() => navigate('/admin/area-reports')} style={{ background: '#6c757d' }}>
          Back
        </button>
      </div>
    );
  }

  return (
    <div style={{ height: '100vh', width: '100vw', background: '#fff' }}>
      <iframe title="Printable report" style={{ width: '100%', height: '100%', border: 0 }} srcDoc={html || '<html><body>Loading...</body></html>'} />
    </div>
  );
};

export default AdminAreaReportPrint;
